import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.7 19.845 6.7 5.181 1.7.293a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.37l3.3 3.225H3c-1.7 0-3 1.27-3 2.933v10.753c0 1.662 1.3 2.933 3 2.933h17.6l1.7 1.662c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.369zM9.5 11.047l.2-.196 4.2 4.106c-.4.293-.9.587-1.4.684-.8.098-1.6 0-2.2-.488-.7-.49-1.1-1.076-1.3-1.858-.1-.782.1-1.564.5-2.248M3 19.551c-.6 0-1-.39-1-.978V7.821c0-.587.4-.978 1-.978h2.6l2.7 2.64c-.2.195-.3.293-.4.488-.8 1.076-1 2.347-.8 3.617s1 2.444 2.1 3.13c.8.585 1.8.88 2.8.88.3 0 .6 0 .9-.099a5.5 5.5 0 0 0 2.4-1.173l3.3 3.226zM21 4.888h-3.5l-1.7-2.542c-.2-.195-.5-.39-.8-.39H9c-.6 0-1 .39-1 .977 0 .586.4.977 1 .977h5.5l1.7 2.542c.2.196.5.391.8.391h4c.6 0 1 .391 1 .978v9.09c0 .587.4.978 1 .978s1-.39 1-.978v-9.09c0-1.662-1.3-2.933-3-2.933"
    }, null, -1)
  ]))]))
}
export default { render: render }